export const data = {
    version: '2026-10-02',
    comuni: [
        {
            istat: '075002',
            name: 'Alessano',
            slug: 'alessano',
            province: 'LE',
            centroid: {
                lat: 39.889679,
                lng: 18.331208,
            },
            frazioni: [
                {
                    name: 'Montesardo',
                    slug: 'montesardo',
                    lat: 39.877213,
                    lng: 18.339485,
                },
                {
                    name: 'Novaglie',
                    slug: 'novaglie',
                    lat: 39.862352,
                    lng: 18.391209,
                },
            ],
            aliases: ['alessano'],
        },
        {
            istat: '075003',
            name: 'Alezio',
            slug: 'alezio',
            province: 'LE',
            centroid: {
                lat: 40.061321,
                lng: 18.058224,
            },
            frazioni: [],
            aliases: ['alezio'],
        },
        {
            istat: '075004',
            name: 'Alliste',
            slug: 'alliste',
            province: 'LE',
            centroid: {
                lat: 39.948618,
                lng: 18.088826,
            },
            frazioni: [
                {
                    name: 'Capilungo',
                    slug: 'capilungo',
                    lat: 39.92647,
                    lng: 18.056466,
                },
                {
                    name: 'Felline',
                    slug: 'felline',
                    lat: 39.936505,
                    lng: 18.117544,
                },
                {
                    name: 'Pacci',
                    slug: 'pacci',
                    lat: 39.941137,
                    lng: 18.052064,
                },
                {
                    name: 'Pilella',
                    slug: 'pilella',
                    lat: 39.922069,
                    lng: 18.064858,
                },
                {
                    name: 'Posto Rosso',
                    slug: 'posto-rosso',
                    lat: 39.905203,
                    lng: 18.082854,
                },
                {
                    name: 'Torre Sinfonò',
                    slug: 'torre-sinfono',
                    lat: 39.9183,
                    lng: 18.070949,
                },
            ],
            aliases: ['alliste'],
        },
        {
            istat: '075005',
            name: 'Andrano',
            slug: 'andrano',
            province: 'LE',
            centroid: {
                lat: 39.983019,
                lng: 18.382202,
            },
            frazioni: [
                {
                    name: "Castiglione d'Otranto",
                    slug: 'castiglione-d-otranto',
                    lat: 39.981705,
                    lng: 18.346836,
                },
                {
                    name: 'Marina di Andrano',
                    slug: 'marina-di-andrano',
                    lat: 39.968456,
                    lng: 18.404094,
                },
            ],
            aliases: ['andrano', 'castiglione'],
        },
        {
            istat: '075006',
            name: 'Aradeo',
            slug: 'aradeo',
            province: 'LE',
            centroid: {
                lat: 40.130922,
                lng: 18.129625,
            },
            frazioni: [],
            aliases: ['aradeo'],
        },
        {
            istat: '075007',
            name: 'Arnesano',
            slug: 'arnesano',
            province: 'LE',
            centroid: {
                lat: 40.3352,
                lng: 18.091628,
            },
            frazioni: [
                {
                    name: 'Rione Riesci',
                    slug: 'rione-riesci',
                    lat: 40.344215,
                    lng: 18.09572,
                },
            ],
            aliases: ['arnesano'],
        },
        {
            istat: '073001',
            name: 'Avetrana',
            slug: 'avetrana',
            province: 'TA',
            centroid: {
                lat: 40.349942,
                lng: 17.727374,
            },
            frazioni: [
                {
                    name: 'Africa',
                    slug: 'africa',
                    lat: 40.339225,
                    lng: 17.734504,
                },
                {
                    name: 'Bizzarro',
                    slug: 'bizzarro',
                    lat: 40.352762,
                    lng: 17.739614,
                },
                {
                    name: 'Casa Sana',
                    slug: 'casa-sana',
                    lat: 40.352955,
                    lng: 17.729917,
                },
                {
                    name: 'Contrada Ronzieri',
                    slug: 'contrada-ronzieri',
                    lat: 40.346325,
                    lng: 17.733861,
                },
                {
                    name: 'Polo Nord',
                    slug: 'polo-nord',
                    lat: 40.347935,
                    lng: 17.737088,
                },
                {
                    name: 'Rione Castello',
                    slug: 'rione-castello',
                    lat: 40.349688,
                    lng: 17.725587,
                },
                {
                    name: 'San Francesco',
                    slug: 'san-francesco',
                    lat: 40.358129,
                    lng: 17.727162,
                },
                {
                    name: 'Santa Maria',
                    slug: 'santa-maria',
                    lat: 40.35418,
                    lng: 17.725133,
                },
                {
                    name: 'Sierri',
                    slug: 'sierri',
                    lat: 40.360639,
                    lng: 17.733335,
                },
                {
                    name: 'Urmo',
                    slug: 'urmo',
                    lat: 40.323563,
                    lng: 17.699793,
                },
            ],
            aliases: ['avetrana'],
        },
        {
            istat: '075008',
            name: 'Bagnolo del Salento',
            slug: 'bagnolo-del-salento',
            province: 'LE',
            centroid: {
                lat: 40.150624,
                lng: 18.35263,
            },
            frazioni: [],
            aliases: ['bagnolo', 'bagnolo del salento'],
        },
        {
            istat: '075009',
            name: 'Botrugno',
            slug: 'botrugno',
            province: 'LE',
            centroid: {
                lat: 40.064722,
                lng: 18.32443,
            },
            frazioni: [],
            aliases: ['botrugno'],
        },
        {
            istat: '074001',
            name: 'Brindisi',
            slug: 'brindisi',
            province: 'BR',
            centroid: {
                lat: 40.637541,
                lng: 17.945496,
            },
            frazioni: [
                {
                    name: 'Bardi Nuovi',
                    slug: 'bardi-nuovi',
                    lat: 40.525764,
                    lng: 17.95254,
                },
                {
                    name: 'Bardi vecchi',
                    slug: 'bardi-vecchi',
                    lat: 40.533185,
                    lng: 17.957438,
                },
                {
                    name: 'Bozzano',
                    slug: 'bozzano',
                    lat: 40.623497,
                    lng: 17.942702,
                },
                {
                    name: 'Cappuccini',
                    slug: 'cappuccini',
                    lat: 40.634535,
                    lng: 17.928755,
                },
                {
                    name: 'Casale',
                    slug: 'casale',
                    lat: 40.647406,
                    lng: 17.943915,
                },
                {
                    name: 'Case Bianche',
                    slug: 'case-bianche',
                    lat: 40.679671,
                    lng: 17.910172,
                },
                {
                    name: 'Commenda',
                    slug: 'commenda',
                    lat: 40.629843,
                    lng: 17.933998,
                },
                {
                    name: 'Contrada Betlemme',
                    slug: 'contrada-betlemme',
                    lat: 40.669783,
                    lng: 17.94102,
                },
                {
                    name: 'Contrada Formosa',
                    slug: 'contrada-formosa',
                    lat: 40.609471,
                    lng: 17.965329,
                },
                {
                    name: 'Contrada Lo Bia',
                    slug: 'contrada-lo-bia',
                    lat: 40.667423,
                    lng: 17.895505,
                },
                {
                    name: 'Contrada Montenegro',
                    slug: 'contrada-montenegro',
                    lat: 40.635328,
                    lng: 17.880431,
                },
                {
                    name: 'Contrada Piccoli',
                    slug: 'contrada-piccoli',
                    lat: 40.622027,
                    lng: 17.962604,
                },
                {
                    name: 'Contrada Restinco',
                    slug: 'contrada-restinco',
                    lat: 40.637958,
                    lng: 17.868254,
                },
                {
                    name: 'La Rosa',
                    slug: 'la-rosa',
                    lat: 40.606087,
                    lng: 17.951963,
                },
                {
                    name: 'Materdomini',
                    slug: 'materdomini',
                    lat: 40.654598,
                    lng: 17.955624,
                },
                {
                    name: 'Minnuta',
                    slug: 'minnuta',
                    lat: 40.637356,
                    lng: 17.926064,
                },
                {
                    name: 'Mitrano',
                    slug: 'mitrano',
                    lat: 40.659616,
                    lng: 17.904223,
                },
                {
                    name: 'Paradiso',
                    slug: 'paradiso',
                    lat: 40.649581,
                    lng: 17.918366,
                },
                {
                    name: 'Perrino',
                    slug: 'perrino',
                    lat: 40.631482,
                    lng: 17.953409,
                },
                {
                    name: "Sant'Angelo",
                    slug: 'sant-angelo',
                    lat: 40.622299,
                    lng: 17.933907,
                },
                {
                    name: "Sant'Elia",
                    slug: 'sant-elia',
                    lat: 40.618466,
                    lng: 17.922156,
                },
                {
                    name: 'Santa Chiara',
                    slug: 'santa-chiara',
                    lat: 40.626294,
                    lng: 17.924817,
                },
                {
                    name: 'Sciaia',
                    slug: 'sciaia',
                    lat: 40.65747,
                    lng: 17.958243,
                },
                {
                    name: 'Torre Mattarelle',
                    slug: 'torre-mattarelle',
                    lat: 40.581723,
                    lng: 18.041887,
                },
                {
                    name: 'Torre Rossa',
                    slug: 'torre-rossa',
                    lat: 40.546951,
                    lng: 17.972678,
                },
                {
                    name: 'Tuturano',
                    slug: 'tuturano',
                    lat: 40.545247,
                    lng: 17.946913,
                },
                {
                    name: 'Villaggio dei Pescatori',
                    slug: 'villaggio-dei-pescatori',
                    lat: 40.64399,
                    lng: 17.940858,
                },
                {
                    name: 'Villaggio San Paolo',
                    slug: 'villaggio-san-paolo',
                    lat: 40.623522,
                    lng: 17.952671,
                },
                {
                    name: 'Villaggio San Pietro',
                    slug: 'villaggio-san-pietro',
                    lat: 40.626838,
                    lng: 17.955765,
                },
                {
                    name: 'Villaggio San Pietro 2',
                    slug: 'villaggio-san-pietro-2',
                    lat: 40.624716,
                    lng: 17.954637,
                },
            ],
            aliases: ['brindisi'],
        },
        {
            istat: '075010',
            name: 'Calimera',
            slug: 'calimera',
            province: 'LE',
            centroid: {
                lat: 40.250022,
                lng: 18.280727,
            },
            frazioni: [],
            aliases: ['calimera', 'kalimera'],
        },
        {
            istat: '075011',
            name: 'Campi Salentina',
            slug: 'campi-salentina',
            province: 'LE',
            centroid: {
                lat: 40.398496,
                lng: 18.018319,
            },
            frazioni: [],
            aliases: ['campi', 'campi salentina'],
        },
        {
            istat: '075012',
            name: 'Cannole',
            slug: 'cannole',
            province: 'LE',
            centroid: {
                lat: 40.166225,
                lng: 18.36603,
            },
            frazioni: [],
            aliases: ['cannole'],
        },
        {
            istat: '075013',
            name: 'Caprarica di Lecce',
            slug: 'caprarica-di-lecce',
            province: 'LE',
            centroid: {
                lat: 40.260598,
                lng: 18.245722,
            },
            frazioni: [],
            aliases: ['caprarica', 'caprarica di lecce'],
        },
        {
            istat: '075014',
            name: 'Carmiano',
            slug: 'carmiano',
            province: 'LE',
            centroid: {
                lat: 40.344826,
                lng: 18.043021,
            },
            frazioni: [
                {
                    name: 'Magliano',
                    slug: 'magliano',
                    lat: 40.338178,
                    lng: 18.061545,
                },
            ],
            aliases: ['carmiano'],
        },
        {
            istat: '073002',
            name: 'Carosino',
            slug: 'carosino',
            province: 'TA',
            centroid: {
                lat: 40.465038,
                lng: 17.399373,
            },
            frazioni: [],
            aliases: ['carosino'],
        },
        {
            istat: '074002',
            name: 'Carovigno',
            slug: 'carovigno',
            province: 'BR',
            centroid: {
                lat: 40.707185,
                lng: 17.656848,
            },
            frazioni: [
                {
                    name: 'Contrada Spierti',
                    slug: 'contrada-spierti',
                    lat: 40.705987,
                    lng: 17.704868,
                },
                {
                    name: 'Lido Bianco',
                    slug: 'lido-bianco',
                    lat: 40.733582,
                    lng: 17.746053,
                },
                {
                    name: 'Pantanagianni',
                    slug: 'pantanagianni',
                    lat: 40.747478,
                    lng: 17.718544,
                },
                {
                    name: 'Pizzofalcone',
                    slug: 'pizzofalcone',
                    lat: 40.657824,
                    lng: 17.766626,
                },
                {
                    name: 'Serranova',
                    slug: 'serranova',
                    lat: 40.692685,
                    lng: 17.762755,
                },
                {
                    name: 'Specchiolla',
                    slug: 'specchiolla',
                    lat: 40.738921,
                    lng: 17.73792,
                },
                {
                    name: 'Torre Santa Sabina',
                    slug: 'torre-santa-sabina',
                    lat: 40.757661,
                    lng: 17.701437,
                },
            ],
            aliases: ['carovigno', 'riserva naturale torre guaceto', 'torre guaceto'],
        },
        {
            istat: '075015',
            name: 'Carpignano Salentino',
            slug: 'carpignano-salentino',
            province: 'LE',
            centroid: {
                lat: 40.197781,
                lng: 18.340827,
            },
            frazioni: [
                {
                    name: 'Serrano',
                    slug: 'serrano',
                    lat: 40.184265,
                    lng: 18.352617,
                },
            ],
            aliases: ['carpignano', 'carpignano salentino'],
        },
        {
            istat: '075016',
            name: 'Casarano',
            slug: 'casarano',
            province: 'LE',
            centroid: {
                lat: 40.01082,
                lng: 18.161765,
            },
            frazioni: [
                {
                    name: 'Casarani',
                    slug: 'casarani',
                    lat: 40.008884,
                    lng: 18.190509,
                },
                {
                    name: 'Colmuni',
                    slug: 'colmuni',
                    lat: 39.999999,
                    lng: 18.153417,
                },
                {
                    name: 'Manfìo',
                    slug: 'manfio',
                    lat: 40.001782,
                    lng: 18.196012,
                },
                {
                    name: 'Monticelli',
                    slug: 'monticelli',
                    lat: 40.005084,
                    lng: 18.200031,
                },
                {
                    name: 'Palla',
                    slug: 'palla',
                    lat: 40.027621,
                    lng: 18.190436,
                },
                {
                    name: 'Pàmpana',
                    slug: 'pampana',
                    lat: 40.012729,
                    lng: 18.18527,
                },
                {
                    name: "Sant'Oronzo",
                    slug: 'sant-oronzo',
                    lat: 40.019923,
                    lng: 18.185395,
                },
                {
                    name: 'Spagnolo',
                    slug: 'spagnolo',
                    lat: 40.025054,
                    lng: 18.176033,
                },
                {
                    name: 'Specchia di Vaje',
                    slug: 'specchia-di-vaje',
                    lat: 40.019659,
                    lng: 18.145662,
                },
                {
                    name: 'Stea',
                    slug: 'stea',
                    lat: 39.996367,
                    lng: 18.16328,
                },
            ],
            aliases: ['casarano'],
        },
        {
            istat: '073003',
            name: 'Castellaneta',
            slug: 'castellaneta',
            province: 'TA',
            centroid: {
                lat: 40.630424,
                lng: 16.934677,
            },
            frazioni: [
                {
                    name: 'Bolzanello',
                    slug: 'bolzanello',
                    lat: 40.63615,
                    lng: 16.920834,
                },
                {
                    name: 'Castellaneta Marina',
                    slug: 'castellaneta-marina',
                    lat: 40.470476,
                    lng: 16.93687,
                },
                {
                    name: 'Città del Catalano',
                    slug: 'citta-del-catalano',
                    lat: 40.464813,
                    lng: 16.908603,
                },
                {
                    name: 'Riva dei Tessali',
                    slug: 'riva-dei-tessali',
                    lat: 40.452401,
                    lng: 16.908088,
                },
            ],
            aliases: ['castellaneta'],
        },
        {
            istat: '075017',
            name: 'Castri di Lecce',
            slug: 'castri-di-lecce',
            province: 'LE',
            centroid: {
                lat: 40.273826,
                lng: 18.263327,
            },
            frazioni: [],
            aliases: ['castri', 'castri di lecce'],
        },
        {
            istat: '075018',
            name: "Castrignano de' Greci",
            slug: 'castrignano-de-greci',
            province: 'LE',
            centroid: {
                lat: 40.173897,
                lng: 18.297011,
            },
            frazioni: [],
            aliases: ['castrignano de greci', 'castrignano dei greci', 'kascignana'],
        },
        {
            istat: '075019',
            name: 'Castrignano del Capo',
            slug: 'castrignano-del-capo',
            province: 'LE',
            centroid: {
                lat: 39.832315,
                lng: 18.350976,
            },
            frazioni: [
                {
                    name: 'Giuliano di Lecce',
                    slug: 'giuliano-di-lecce',
                    lat: 39.848991,
                    lng: 18.336874,
                },
                {
                    name: 'Marina di Felloniche',
                    slug: 'marina-di-felloniche',
                    lat: 39.808107,
                    lng: 18.3254,
                },
                {
                    name: 'Salignano',
                    slug: 'salignano',
                    lat: 39.833205,
                    lng: 18.358278,
                },
                {
                    name: 'Santa Maria di Leuca',
                    slug: 'santa-maria-di-leuca',
                    lat: 39.796749,
                    lng: 18.35449,
                },
            ],
            aliases: ['castrignano del capo', 'leuca'],
        },
        {
            istat: '075096',
            name: 'Castro',
            slug: 'castro',
            province: 'LE',
            centroid: {
                lat: 40.007022,
                lng: 18.425733,
            },
            frazioni: [
                {
                    name: 'Castro Marina',
                    slug: 'castro-marina',
                    lat: 40.000028,
                    lng: 18.42238,
                },
                {
                    name: 'Porto Romanelli',
                    slug: 'porto-romanelli',
                    lat: 40.015149,
                    lng: 18.434785,
                },
            ],
            aliases: ['castro'],
        },
        {
            istat: '075020',
            name: 'Cavallino',
            slug: 'cavallino',
            province: 'LE',
            centroid: {
                lat: 40.312527,
                lng: 18.200425,
            },
            frazioni: [
                {
                    name: 'Castromediano',
                    slug: 'castromediano',
                    lat: 40.326857,
                    lng: 18.179774,
                },
            ],
            aliases: ['cavallino'],
        },
        {
            istat: '074003',
            name: 'Ceglie Messapica',
            slug: 'ceglie-messapica',
            province: 'BR',
            centroid: {
                lat: 40.646044,
                lng: 17.517057,
            },
            frazioni: [],
            aliases: ['ceglie', 'ceglie messapica', 'ceglie messapico'],
        },
        {
            istat: '074004',
            name: 'Cellino San Marco',
            slug: 'cellino-san-marco',
            province: 'BR',
            centroid: {
                lat: 40.472031,
                lng: 17.966152,
            },
            frazioni: [],
            aliases: ['cellino san marco'],
        },
        {
            istat: '074005',
            name: 'Cisternino',
            slug: 'cisternino',
            province: 'BR',
            centroid: {
                lat: 40.742985,
                lng: 17.425745,
            },
            frazioni: [
                {
                    name: 'Caranna',
                    slug: 'caranna',
                    lat: 40.770633,
                    lng: 17.423802,
                },
                {
                    name: 'Casalini',
                    slug: 'casalini',
                    lat: 40.737567,
                    lng: 17.473501,
                },
                {
                    name: 'La Specchia',
                    slug: 'la-specchia',
                    lat: 40.751707,
                    lng: 17.476176,
                },
            ],
            aliases: ['cisternino'],
        },
        {
            istat: '075021',
            name: 'Collepasso',
            slug: 'collepasso',
            province: 'LE',
            centroid: {
                lat: 40.07302,
                lng: 18.163073,
            },
            frazioni: [],
            aliases: ['collepasso'],
        },
        {
            istat: '075022',
            name: 'Copertino',
            slug: 'copertino',
            province: 'LE',
            centroid: {
                lat: 40.271681,
                lng: 18.050252,
            },
            frazioni: [],
            aliases: ['copertino'],
        },
        {
            istat: '075023',
            name: "Corigliano d'Otranto",
            slug: 'corigliano-d-otranto',
            province: 'LE',
            centroid: {
                lat: 40.159624,
                lng: 18.259428,
            },
            frazioni: [],
            aliases: ['choriana', 'corigliano', 'corigliano d otranto', 'corigliano di otranto'],
        },
        {
            istat: '075024',
            name: 'Corsano',
            slug: 'corsano',
            province: 'LE',
            centroid: {
                lat: 39.889316,
                lng: 18.366182,
            },
            frazioni: [
                {
                    name: 'Contrada Guardiola',
                    slug: 'contrada-guardiola',
                    lat: 39.873004,
                    lng: 18.396445,
                },
            ],
            aliases: ['corsano'],
        },
        {
            istat: '073004',
            name: 'Crispiano',
            slug: 'crispiano',
            province: 'TA',
            centroid: {
                lat: 40.60525,
                lng: 17.231303,
            },
            frazioni: [
                {
                    name: 'San Simone',
                    slug: 'san-simone',
                    lat: 40.617048,
                    lng: 17.265104,
                },
            ],
            aliases: ['crispiano'],
        },
        {
            istat: '075025',
            name: 'Cursi',
            slug: 'cursi',
            province: 'LE',
            centroid: {
                lat: 40.149624,
                lng: 18.314829,
            },
            frazioni: [],
            aliases: ['cursi'],
        },
        {
            istat: '075026',
            name: 'Cutrofiano',
            slug: 'cutrofiano',
            province: 'LE',
            centroid: {
                lat: 40.126181,
                lng: 18.201557,
            },
            frazioni: [],
            aliases: ['cutrofiano'],
        },
        {
            istat: '075027',
            name: 'Diso',
            slug: 'diso',
            province: 'LE',
            centroid: {
                lat: 40.009303,
                lng: 18.392467,
            },
            frazioni: [
                {
                    name: 'Marina di Marittima',
                    slug: 'marina-di-marittima',
                    lat: 39.986248,
                    lng: 18.411798,
                },
                {
                    name: 'Marittima',
                    slug: 'marittima',
                    lat: 39.9963,
                    lng: 18.399916,
                },
            ],
            aliases: ['diso'],
        },
        {
            istat: '074006',
            name: 'Erchie',
            slug: 'erchie',
            province: 'BR',
            centroid: {
                lat: 40.436042,
                lng: 17.734629,
            },
            frazioni: [],
            aliases: ['erchie'],
        },
        {
            istat: '073005',
            name: 'Faggiano',
            slug: 'faggiano',
            province: 'TA',
            centroid: {
                lat: 40.419823,
                lng: 17.386605,
            },
            frazioni: [
                {
                    name: 'San Crispieri',
                    slug: 'san-crispieri',
                    lat: 40.404389,
                    lng: 17.394467,
                },
            ],
            aliases: ['faggiano'],
        },
        {
            istat: '074007',
            name: 'Fasano',
            slug: 'fasano',
            province: 'BR',
            centroid: {
                lat: 40.834432,
                lng: 17.358399,
            },
            frazioni: [
                {
                    name: 'Canale di Pirro',
                    slug: 'canale-di-pirro',
                    lat: 40.810747,
                    lng: 17.342333,
                },
                {
                    name: 'Egnazia scavi',
                    slug: 'egnazia-scavi',
                    lat: 40.887693,
                    lng: 17.390798,
                },
                {
                    name: 'Fascianello',
                    slug: 'fascianello',
                    lat: 40.864355,
                    lng: 17.353594,
                },
                {
                    name: 'Lamascopone',
                    slug: 'lamascopone',
                    lat: 40.852308,
                    lng: 17.372843,
                },
                {
                    name: 'Montalbano',
                    slug: 'montalbano',
                    lat: 40.778295,
                    lng: 17.478183,
                },
                {
                    name: 'Pezze di Greco',
                    slug: 'pezze-di-greco',
                    lat: 40.813415,
                    lng: 17.411246,
                },
                {
                    name: 'Pozzo Faceto',
                    slug: 'pozzo-faceto',
                    lat: 40.807428,
                    lng: 17.452077,
                },
                {
                    name: 'Savelletri',
                    slug: 'savelletri',
                    lat: 40.87303,
                    lng: 17.408961,
                },
                {
                    name: 'Scanzossa',
                    slug: 'scanzossa',
                    lat: 40.84249,
                    lng: 17.385455,
                },
                {
                    name: 'Selva',
                    slug: 'selva',
                    lat: 40.829477,
                    lng: 17.320516,
                },
                {
                    name: 'Selva di Fasano',
                    slug: 'selva-di-fasano',
                    lat: 40.829465,
                    lng: 17.319257,
                },
                {
                    name: 'Speziale',
                    slug: 'speziale',
                    lat: 40.791391,
                    lng: 17.459864,
                },
                {
                    name: 'Torre Canne',
                    slug: 'torre-canne',
                    lat: 40.838873,
                    lng: 17.465498,
                },
            ],
            aliases: ['cocolicchio', 'fasano'],
        },
        {
            istat: '073006',
            name: 'Fragagnano',
            slug: 'fragagnano',
            province: 'TA',
            centroid: {
                lat: 40.431924,
                lng: 17.472207,
            },
            frazioni: [],
            aliases: ['fragagnano'],
        },
        {
            istat: '074008',
            name: 'Francavilla Fontana',
            slug: 'francavilla-fontana',
            province: 'BR',
            centroid: {
                lat: 40.530162,
                lng: 17.582677,
            },
            frazioni: [
                {
                    name: 'Bax Capece',
                    slug: 'bax-capece',
                    lat: 40.583274,
                    lng: 17.561066,
                },
            ],
            aliases: ['francavilla fontana'],
        },
        {
            istat: '075028',
            name: 'Gagliano del Capo',
            slug: 'gagliano-del-capo',
            province: 'LE',
            centroid: {
                lat: 39.844218,
                lng: 18.369534,
            },
            frazioni: [
                {
                    name: 'Arigliano',
                    slug: 'arigliano',
                    lat: 39.846885,
                    lng: 18.361662,
                },
                {
                    name: 'Chiani',
                    slug: 'chiani',
                    lat: 39.815423,
                    lng: 18.373387,
                },
                {
                    name: 'San Dana',
                    slug: 'san-dana',
                    lat: 39.864051,
                    lng: 18.35319,
                },
            ],
            aliases: ['gagliano', 'gagliano del capo'],
        },
        {
            istat: '075029',
            name: 'Galatina',
            slug: 'galatina',
            province: 'LE',
            centroid: {
                lat: 40.174278,
                lng: 18.167839,
            },
            frazioni: [
                {
                    name: 'Collemeto',
                    slug: 'collemeto',
                    lat: 40.208296,
                    lng: 18.105034,
                },
                {
                    name: 'Contrada Guidano',
                    slug: 'contrada-guidano',
                    lat: 40.185621,
                    lng: 18.144009,
                },
                {
                    name: 'Contrada Notaro Iaco',
                    slug: 'contrada-notaro-iaco',
                    lat: 40.171351,
                    lng: 18.148999,
                },
                {
                    name: 'Contrada Paradisi',
                    slug: 'contrada-paradisi',
                    lat: 40.203131,
                    lng: 18.152794,
                },
                {
                    name: 'Contrada Piani',
                    slug: 'contrada-piani',
                    lat: 40.160658,
                    lng: 18.194312,
                },
                {
                    name: 'Contrada Scorpio-Galatina',
                    slug: 'contrada-scorpio-galatina',
                    lat: 40.162692,
                    lng: 18.148667,
                },
                {
                    name: 'Contrada Scorpio-Noha',
                    slug: 'contrada-scorpio-noha',
                    lat: 40.157541,
                    lng: 18.155431,
                },
                {
                    name: 'Contrada Spina',
                    slug: 'contrada-spina',
                    lat: 40.154867,
                    lng: 18.11882,
                },
                {
                    name: 'Mariantonio',
                    slug: 'mariantonio',
                    lat: 40.153815,
                    lng: 18.192887,
                },
                {
                    name: 'Noha',
                    slug: 'noha',
                    lat: 40.153443,
                    lng: 18.16642,
                },
                {
                    name: 'Santa Barbara',
                    slug: 'santa-barbara',
                    lat: 40.223505,
                    lng: 18.078983,
                },
                {
                    name: 'Villaggio Azzurro',
                    slug: 'villaggio-azzurro',
                    lat: 40.241241,
                    lng: 18.145401,
                },
            ],
            aliases: ['galatina'],
        },
        {
            istat: '075030',
            name: 'Galatone',
            slug: 'galatone',
            province: 'LE',
            centroid: {
                lat: 40.142922,
                lng: 18.070424,
            },
            frazioni: [
                {
                    name: 'Villaggio Santa Rita',
                    slug: 'villaggio-santa-rita',
                    lat: 40.126166,
                    lng: 18.011375,
                },
            ],
            aliases: ['galatone'],
        },
        {
            istat: '075031',
            name: 'Gallipoli',
            slug: 'gallipoli',
            province: 'LE',
            centroid: {
                lat: 40.054694,
                lng: 17.975785,
            },
            frazioni: [
                {
                    name: 'Baia Verde',
                    slug: 'baia-verde',
                    lat: 40.037607,
                    lng: 18.016506,
                },
                {
                    name: 'Lido Conchiglie',
                    slug: 'lido-conchiglie',
                    lat: 40.108523,
                    lng: 18.010976,
                },
                {
                    name: 'Padula Bianca',
                    slug: 'padula-bianca',
                    lat: 40.09721,
                    lng: 18.015625,
                },
                {
                    name: 'Rivabella di Gallipoli',
                    slug: 'rivabella-di-gallipoli',
                    lat: 40.087482,
                    lng: 18.01255,
                },
            ],
            aliases: ['gallipoli', 'parco gondar'],
        },
        {
            istat: '073007',
            name: 'Ginosa',
            slug: 'ginosa',
            province: 'TA',
            centroid: {
                lat: 40.579751,
                lng: 16.756208,
            },
            frazioni: [
                {
                    name: 'Marina di Ginosa',
                    slug: 'marina-di-ginosa',
                    lat: 40.429595,
                    lng: 16.890495,
                },
            ],
            aliases: ['ginosa'],
        },
        {
            istat: '075032',
            name: 'Giuggianello',
            slug: 'giuggianello',
            province: 'LE',
            centroid: {
                lat: 40.094423,
                lng: 18.368931,
            },
            frazioni: [],
            aliases: ['giuggianello'],
        },
        {
            istat: '075033',
            name: 'Giurdignano',
            slug: 'giurdignano',
            province: 'LE',
            centroid: {
                lat: 40.123655,
                lng: 18.431686,
            },
            frazioni: [],
            aliases: ['giurdignano'],
        },
        {
            istat: '073008',
            name: 'Grottaglie',
            slug: 'grottaglie',
            province: 'TA',
            centroid: {
                lat: 40.536193,
                lng: 17.434221,
            },
            frazioni: [
                {
                    name: 'Quartiere delle Ceramiche',
                    slug: 'quartiere-delle-ceramiche',
                    lat: 40.533527,
                    lng: 17.432147,
                },
            ],
            aliases: ['grottaglie'],
        },
        {
            istat: '075034',
            name: 'Guagnano',
            slug: 'guagnano',
            province: 'LE',
            centroid: {
                lat: 40.401227,
                lng: 17.949018,
            },
            frazioni: [
                {
                    name: 'Villa Baldassarri',
                    slug: 'villa-baldassarri',
                    lat: 40.415467,
                    lng: 17.964962,
                },
            ],
            aliases: ['guagnano'],
        },
        {
            istat: '073009',
            name: 'Laterza',
            slug: 'laterza',
            province: 'TA',
            centroid: {
                lat: 40.629524,
                lng: 16.799689,
            },
            frazioni: [],
            aliases: ['laterza'],
        },
        {
            istat: '074009',
            name: 'Latiano',
            slug: 'latiano',
            province: 'BR',
            centroid: {
                lat: 40.553783,
                lng: 17.718222,
            },
            frazioni: [],
            aliases: ['latiano'],
        },
        {
            istat: '075035',
            name: 'Lecce',
            slug: 'lecce',
            province: 'LE',
            centroid: {
                lat: 40.357037,
                lng: 18.171848,
            },
            frazioni: [
                {
                    name: 'Borgo Piave',
                    slug: 'borgo-piave',
                    lat: 40.416037,
                    lng: 18.218201,
                },
                {
                    name: 'Casa Simini',
                    slug: 'casa-simini',
                    lat: 40.45167,
                    lng: 18.205487,
                },
                {
                    name: 'Frigole',
                    slug: 'frigole',
                    lat: 40.42838,
                    lng: 18.245748,
                },
                {
                    name: 'Marangi',
                    slug: 'marangi',
                    lat: 40.36692,
                    lng: 18.230648,
                },
                {
                    name: 'Masseria Cucchiarari',
                    slug: 'masseria-cucchiarari',
                    lat: 40.380251,
                    lng: 18.281955,
                },
                {
                    name: 'Masseria Grande',
                    slug: 'masseria-grande',
                    lat: 40.405791,
                    lng: 18.202279,
                },
                {
                    name: 'Masseria Liuni',
                    slug: 'masseria-liuni',
                    lat: 40.385125,
                    lng: 18.1878,
                },
                {
                    name: 'Masseria Marsello',
                    slug: 'masseria-marsello',
                    lat: 40.360095,
                    lng: 18.099797,
                },
                {
                    name: 'Masseria Seminario',
                    slug: 'masseria-seminario',
                    lat: 40.384783,
                    lng: 18.170966,
                },
                {
                    name: 'Masseria Solicara-Gelsi',
                    slug: 'masseria-solicara-gelsi',
                    lat: 40.438361,
                    lng: 18.189034,
                },
                {
                    name: 'Mezzagrande',
                    slug: 'mezzagrande',
                    lat: 40.372311,
                    lng: 18.237115,
                },
                {
                    name: 'San Cataldo',
                    slug: 'san-cataldo',
                    lat: 40.390188,
                    lng: 18.306178,
                },
                {
                    name: 'San Ligorio',
                    slug: 'san-ligorio',
                    lat: 40.377514,
                    lng: 18.214715,
                },
                {
                    name: 'Torre Chianca',
                    slug: 'torre-chianca',
                    lat: 40.462914,
                    lng: 18.202223,
                },
                {
                    name: 'Torre Rinalda',
                    slug: 'torre-rinalda',
                    lat: 40.47564,
                    lng: 18.173349,
                },
                {
                    name: 'Torre San Giuseppe',
                    slug: 'torre-san-giuseppe',
                    lat: 40.465973,
                    lng: 18.157587,
                },
                {
                    name: 'Villa Convento',
                    slug: 'villa-convento',
                    lat: 40.365075,
                    lng: 18.077169,
                },
                {
                    name: 'Villaggio Adriatico',
                    slug: 'villaggio-adriatico',
                    lat: 40.383699,
                    lng: 18.290991,
                },
                {
                    name: 'Villaggio Dario',
                    slug: 'villaggio-dario',
                    lat: 40.386554,
                    lng: 18.270275,
                },
                {
                    name: 'Villaggio del Sole',
                    slug: 'villaggio-del-sole',
                    lat: 40.379211,
                    lng: 18.261299,
                },
                {
                    name: 'Villaggio Gelsi',
                    slug: 'villaggio-gelsi',
                    lat: 40.454755,
                    lng: 18.188937,
                },
                {
                    name: 'Villaggio Wojtila',
                    slug: 'villaggio-wojtila',
                    lat: 40.384039,
                    lng: 18.284141,
                },
                {
                    name: 'Zona Montegrappa',
                    slug: 'zona-montegrappa',
                    lat: 40.452428,
                    lng: 18.217389,
                },
            ],
            aliases: ['abbazia di cerrate', 'cerrate', 'lecce'],
        },
        {
            istat: '073010',
            name: 'Leporano',
            slug: 'leporano',
            province: 'TA',
            centroid: {
                lat: 40.383922,
                lng: 17.334904,
            },
            frazioni: [
                {
                    name: "Baia d'Argento",
                    slug: 'baia-d-argento',
                    lat: 40.363558,
                    lng: 17.330151,
                },
                {
                    name: 'Palumbo',
                    slug: 'palumbo',
                    lat: 40.397026,
                    lng: 17.307201,
                },
            ],
            aliases: ['leporano'],
        },
        {
            istat: '075036',
            name: 'Lequile',
            slug: 'lequile',
            province: 'LE',
            centroid: {
                lat: 40.305826,
                lng: 18.140223,
            },
            frazioni: [
                {
                    name: 'Dragoni',
                    slug: 'dragoni',
                    lat: 40.295518,
                    lng: 18.142278,
                },
            ],
            aliases: ['lequile'],
        },
        {
            istat: '075037',
            name: 'Leverano',
            slug: 'leverano',
            province: 'LE',
            centroid: {
                lat: 40.289425,
                lng: 17.999414,
            },
            frazioni: [],
            aliases: ['leverano'],
        },
        {
            istat: '075038',
            name: 'Lizzanello',
            slug: 'lizzanello',
            province: 'LE',
            centroid: {
                lat: 40.304127,
                lng: 18.222525,
            },
            frazioni: [
                {
                    name: 'Merine',
                    slug: 'merine',
                    lat: 40.334497,
                    lng: 18.223922,
                },
                {
                    name: 'Zona Marangi',
                    slug: 'zona-marangi',
                    lat: 40.334969,
                    lng: 18.241514,
                },
            ],
            aliases: ['lizzanello'],
        },
        {
            istat: '073011',
            name: 'Lizzano',
            slug: 'lizzano',
            province: 'TA',
            centroid: {
                lat: 40.391023,
                lng: 17.447607,
            },
            frazioni: [
                {
                    name: 'Contrada Belvedere',
                    slug: 'contrada-belvedere',
                    lat: 40.379268,
                    lng: 17.451133,
                },
                {
                    name: 'Le Conche',
                    slug: 'le-conche',
                    lat: 40.319594,
                    lng: 17.456394,
                },
                {
                    name: 'Marina di Lizzano',
                    slug: 'marina-di-lizzano',
                    lat: 40.326388,
                    lng: 17.454159,
                },
                {
                    name: 'Palmintiello',
                    slug: 'palmintiello',
                    lat: 40.31741,
                    lng: 17.465296,
                },
            ],
            aliases: ['lizzano'],
        },
        {
            istat: '075039',
            name: 'Maglie',
            slug: 'maglie',
            province: 'LE',
            centroid: {
                lat: 40.118463,
                lng: 18.298853,
            },
            frazioni: [
                {
                    name: 'Morigino',
                    slug: 'morigino',
                    lat: 40.141715,
                    lng: 18.309836,
                },
            ],
            aliases: ['maglie'],
        },
        {
            istat: '073012',
            name: 'Manduria',
            slug: 'manduria',
            province: 'TA',
            centroid: {
                lat: 40.401825,
                lng: 17.633511,
            },
            frazioni: [
                {
                    name: 'Marchese',
                    slug: 'marchese',
                    lat: 40.302915,
                    lng: 17.61259,
                },
                {
                    name: 'San Pietro in Bevagna',
                    slug: 'san-pietro-in-bevagna',
                    lat: 40.306846,
                    lng: 17.672507,
                },
                {
                    name: 'S. Gemma',
                    slug: 's-gemma',
                    lat: 40.406603,
                    lng: 17.637158,
                },
                {
                    name: 'Specchiarica',
                    slug: 'specchiarica',
                    lat: 40.303499,
                    lng: 17.715574,
                },
                {
                    name: 'Torre Colimena',
                    slug: 'torre-colimena',
                    lat: 40.29755,
                    lng: 17.74493,
                },
                {
                    name: 'Uggiano Montefusco',
                    slug: 'uggiano-montefusco',
                    lat: 40.387491,
                    lng: 17.603849,
                },
            ],
            aliases: ['manduria'],
        },
        {
            istat: '075040',
            name: 'Martano',
            slug: 'martano',
            province: 'LE',
            centroid: {
                lat: 40.203621,
                lng: 18.30198,
            },
            frazioni: [],
            aliases: ['martana', 'martano'],
        },
        {
            istat: '075041',
            name: 'Martignano',
            slug: 'martignano',
            province: 'LE',
            centroid: {
                lat: 40.238159,
                lng: 18.256995,
            },
            frazioni: [],
            aliases: ['martignana', 'martignano'],
        },
        {
            istat: '073013',
            name: 'Martina Franca',
            slug: 'martina-franca',
            province: 'TA',
            centroid: {
                lat: 40.704238,
                lng: 17.339991,
            },
            frazioni: [
                {
                    name: 'San Paolo',
                    slug: 'san-paolo',
                    lat: 40.644182,
                    lng: 17.318696,
                },
                {
                    name: 'Specchia Tarantina',
                    slug: 'specchia-tarantina',
                    lat: 40.619801,
                    lng: 17.430321,
                },
            ],
            aliases: ['martina franca'],
        },
        {
            istat: '073014',
            name: 'Maruggio',
            slug: 'maruggio',
            province: 'TA',
            centroid: {
                lat: 40.32226,
                lng: 17.572366,
            },
            frazioni: [
                {
                    name: 'Campomarino di Maruggio',
                    slug: 'campomarino-di-maruggio',
                    lat: 40.298197,
                    lng: 17.56387,
                },
                {
                    name: 'Torre Ovo',
                    slug: 'torre-ovo',
                    lat: 40.302471,
                    lng: 17.505551,
                },
            ],
            aliases: ['maruggio'],
        },
        {
            istat: '073015',
            name: 'Massafra',
            slug: 'massafra',
            province: 'TA',
            centroid: {
                lat: 40.588488,
                lng: 17.112079,
            },
            frazioni: [],
            aliases: ['massafra'],
        },
        {
            istat: '075042',
            name: 'Matino',
            slug: 'matino',
            province: 'LE',
            centroid: {
                lat: 40.03251,
                lng: 18.133853,
            },
            frazioni: [],
            aliases: ['matino'],
        },
        {
            istat: '075043',
            name: 'Melendugno',
            slug: 'melendugno',
            province: 'LE',
            centroid: {
                lat: 40.271701,
                lng: 18.336911,
            },
            frazioni: [
                {
                    name: 'Borgagne',
                    slug: 'borgagne',
                    lat: 40.240553,
                    lng: 18.376739,
                },
                {
                    name: 'Madonna di Roca Vecchia',
                    slug: 'madonna-di-roca-vecchia',
                    lat: 40.285678,
                    lng: 18.426022,
                },
                {
                    name: 'Roca',
                    slug: 'roca',
                    lat: 40.291215,
                    lng: 18.423199,
                },
                {
                    name: 'San Foca',
                    slug: 'san-foca',
                    lat: 40.301863,
                    lng: 18.403795,
                },
                {
                    name: "Sant'Andrea",
                    slug: 'sant-andrea',
                    lat: 40.255116,
                    lng: 18.444518,
                },
                {
                    name: "Torre dell'Orso",
                    slug: 'torre-dell-orso',
                    lat: 40.275291,
                    lng: 18.427567,
                },
                {
                    name: 'Torre Saracena',
                    slug: 'torre-saracena',
                    lat: 40.257213,
                    lng: 18.431057,
                },
                {
                    name: 'Torre Specchia Ruggeri',
                    slug: 'torre-specchia-ruggeri',
                    lat: 40.320037,
                    lng: 18.376604,
                },
            ],
            aliases: ['melendugno', 'roca nuova', 'roca vecchia', 'torre sant andrea'],
        },
        {
            istat: '075044',
            name: 'Melissano',
            slug: 'melissano',
            province: 'LE',
            centroid: {
                lat: 39.971064,
                lng: 18.125779,
            },
            frazioni: [],
            aliases: ['melissano'],
        },
        {
            istat: '075045',
            name: 'Melpignano',
            slug: 'melpignano',
            province: 'LE',
            centroid: {
                lat: 40.157081,
                lng: 18.293079,
            },
            frazioni: [],
            aliases: ['lipignana', 'melpignano'],
        },
        {
            istat: '074010',
            name: 'Mesagne',
            slug: 'mesagne',
            province: 'BR',
            centroid: {
                lat: 40.559754,
                lng: 17.808546,
            },
            frazioni: [
                {
                    name: 'Contrada Cavallino',
                    slug: 'contrada-cavallino',
                    lat: 40.576019,
                    lng: 17.836278,
                },
            ],
            aliases: ['mesagne'],
        },
        {
            istat: '075046',
            name: 'Miggiano',
            slug: 'miggiano',
            province: 'LE',
            centroid: {
                lat: 39.95972,
                lng: 18.311631,
            },
            frazioni: [
                {
                    name: 'San Giovacchino',
                    slug: 'san-giovacchino',
                    lat: 39.963132,
                    lng: 18.319794,
                },
            ],
            aliases: ['miggiano'],
        },
        {
            istat: '075047',
            name: 'Minervino di Lecce',
            slug: 'minervino-di-lecce',
            province: 'LE',
            centroid: {
                lat: 40.089475,
                lng: 18.422612,
            },
            frazioni: [
                {
                    name: 'Cocumola',
                    slug: 'cocumola',
                    lat: 40.066352,
                    lng: 18.431568,
                },
                {
                    name: 'Specchia Gallone',
                    slug: 'specchia-gallone',
                    lat: 40.08816,
                    lng: 18.409426,
                },
            ],
            aliases: ['minervino', 'minervino di lecce'],
        },
        {
            istat: '073016',
            name: 'Monteiasi',
            slug: 'monteiasi',
            province: 'TA',
            centroid: {
                lat: 40.499725,
                lng: 17.381007,
            },
            frazioni: [],
            aliases: ['monteiasi'],
        },
        {
            istat: '073017',
            name: 'Montemesola',
            slug: 'montemesola',
            province: 'TA',
            centroid: {
                lat: 40.56376,
                lng: 17.339365,
            },
            frazioni: [],
            aliases: ['montemesola'],
        },
        {
            istat: '073018',
            name: 'Monteparano',
            slug: 'monteparano',
            province: 'TA',
            centroid: {
                lat: 40.444024,
                lng: 17.415105,
            },
            frazioni: [],
            aliases: ['monteparano'],
        },
        {
            istat: '075048',
            name: 'Monteroni di Lecce',
            slug: 'monteroni-di-lecce',
            province: 'LE',
            centroid: {
                lat: 40.324398,
                lng: 18.09759,
            },
            frazioni: [],
            aliases: ['monteroni', 'monteroni di lecce'],
        },
        {
            istat: '075049',
            name: 'Montesano Salentino',
            slug: 'montesano-salentino',
            province: 'LE',
            centroid: {
                lat: 39.975621,
                lng: 18.321431,
            },
            frazioni: [],
            aliases: ['montesano', 'montesano salentino'],
        },
        {
            istat: '075050',
            name: 'Morciano di Leuca',
            slug: 'morciano-di-leuca',
            province: 'LE',
            centroid: {
                lat: 39.847986,
                lng: 18.309818,
            },
            frazioni: [
                {
                    name: 'Barbarano del Capo',
                    slug: 'barbarano-del-capo',
                    lat: 39.863297,
                    lng: 18.326666,
                },
                {
                    name: 'Torre Vado',
                    slug: 'torre-vado',
                    lat: 39.833737,
                    lng: 18.274698,
                },
            ],
            aliases: ['barbarano', 'morciano', 'morciano di leuca'],
        },
        {
            istat: '073019',
            name: 'Mottola',
            slug: 'mottola',
            province: 'TA',
            centroid: {
                lat: 40.633225,
                lng: 17.037195,
            },
            frazioni: [
                {
                    name: 'Centro storico Schiavonia',
                    slug: 'centro-storico-schiavonia',
                    lat: 40.635088,
                    lng: 17.037757,
                },
                {
                    name: 'San Basilio',
                    slug: 'san-basilio',
                    lat: 40.688316,
                    lng: 16.975612,
                },
            ],
            aliases: ['mottola'],
        },
        {
            istat: '075051',
            name: 'Muro Leccese',
            slug: 'muro-leccese',
            province: 'LE',
            centroid: {
                lat: 40.102323,
                lng: 18.33813,
            },
            frazioni: [],
            aliases: ['muro', 'muro leccese'],
        },
        {
            istat: '075052',
            name: 'Nardò',
            slug: 'nardo',
            province: 'LE',
            centroid: {
                lat: 40.176261,
                lng: 18.030637,
            },
            frazioni: [
                {
                    name: 'Boncore',
                    slug: 'boncore',
                    lat: 40.295845,
                    lng: 17.858206,
                },
                {
                    name: 'Contrada Campo dei Fiori',
                    slug: 'contrada-campo-dei-fiori',
                    lat: 40.160684,
                    lng: 18.008668,
                },
                {
                    name: 'Frascone',
                    slug: 'frascone',
                    lat: 40.207751,
                    lng: 17.925657,
                },
                {
                    name: 'Masseria Auletta',
                    slug: 'masseria-auletta',
                    lat: 40.212278,
                    lng: 17.987734,
                },
                {
                    name: 'Pagani',
                    slug: 'pagani',
                    lat: 40.15688,
                    lng: 18.020642,
                },
                {
                    name: 'Rione Bentivenga',
                    slug: 'rione-bentivenga',
                    lat: 40.133437,
                    lng: 17.994922,
                },
                {
                    name: "Sant'Isidoro",
                    slug: 'sant-isidoro',
                    lat: 40.215894,
                    lng: 17.927842,
                },
                {
                    name: 'Santa Caterina',
                    slug: 'santa-caterina',
                    lat: 40.14101,
                    lng: 17.98411,
                },
                {
                    name: 'Santa Maria al Bagno',
                    slug: 'santa-maria-al-bagno',
                    lat: 40.129683,
                    lng: 17.998217,
                },
                {
                    name: 'Torre Inserraglio',
                    slug: 'torre-inserraglio',
                    lat: 40.183974,
                    lng: 17.932219,
                },
                {
                    name: 'Torre Squillace',
                    slug: 'torre-squillace',
                    lat: 40.237131,
                    lng: 17.915202,
                },
                {
                    name: 'Villaggio Resta',
                    slug: 'villaggio-resta',
                    lat: 40.201998,
                    lng: 17.958183,
                },
            ],
            aliases: ['cenate', 'nardo', 'porto selvaggio', 'portoselvaggio'],
        },
        {
            istat: '075053',
            name: 'Neviano',
            slug: 'neviano',
            province: 'LE',
            centroid: {
                lat: 40.107722,
                lng: 18.114025,
            },
            frazioni: [],
            aliases: ['neviano'],
        },
        {
            istat: '075054',
            name: 'Nociglia',
            slug: 'nociglia',
            province: 'LE',
            centroid: {
                lat: 40.039222,
                lng: 18.326031,
            },
            frazioni: [],
            aliases: ['nociglia'],
        },
        {
            istat: '075055',
            name: 'Novoli',
            slug: 'novoli',
            province: 'LE',
            centroid: {
                lat: 40.378527,
                lng: 18.04922,
            },
            frazioni: [
                {
                    name: 'Zona di Lallo',
                    slug: 'zona-di-lallo',
                    lat: 40.387738,
                    lng: 18.07041,
                },
            ],
            aliases: ['novoli'],
        },
        {
            istat: '074011',
            name: 'Oria',
            slug: 'oria',
            province: 'BR',
            centroid: {
                lat: 40.497327,
                lng: 17.64131,
            },
            frazioni: [
                {
                    name: 'Contrada S. Cosimo',
                    slug: 'contrada-s-cosimo',
                    lat: 40.459346,
                    lng: 17.676299,
                },
                {
                    name: 'Quartiere ebraico',
                    slug: 'quartiere-ebraico',
                    lat: 40.499328,
                    lng: 17.640464,
                },
            ],
            aliases: ['oria'],
        },
        {
            istat: '075056',
            name: 'Ortelle',
            slug: 'ortelle',
            province: 'LE',
            centroid: {
                lat: 40.033896,
                lng: 18.39112,
            },
            frazioni: [
                {
                    name: 'Vignacastrisi',
                    slug: 'vignacastrisi',
                    lat: 40.016387,
                    lng: 18.406495,
                },
            ],
            aliases: ['ortelle'],
        },
        {
            istat: '074012',
            name: 'Ostuni',
            slug: 'ostuni',
            province: 'BR',
            centroid: {
                lat: 40.727631,
                lng: 17.576406,
            },
            frazioni: [
                {
                    name: 'Borgo Rurale Pascarosa',
                    slug: 'borgo-rurale-pascarosa',
                    lat: 40.69559,
                    lng: 17.47052,
                },
                {
                    name: 'Cala di Rosamarina',
                    slug: 'cala-di-rosamarina',
                    lat: 40.801964,
                    lng: 17.546101,
                },
                {
                    name: 'Contrada Badessa',
                    slug: 'contrada-badessa',
                    lat: 40.72865,
                    lng: 17.516848,
                },
                {
                    name: 'Diana Marina',
                    slug: 'diana-marina',
                    lat: 40.79131,
                    lng: 17.57804,
                },
                {
                    name: 'Monticelli',
                    slug: 'monticelli',
                    lat: 40.794939,
                    lng: 17.568995,
                },
                {
                    name: 'Pilone',
                    slug: 'pilone',
                    lat: 40.803704,
                    lng: 17.537111,
                },
                {
                    name: 'Rosa Marina di Ostuni',
                    slug: 'rosa-marina-di-ostuni',
                    lat: 40.793788,
                    lng: 17.545018,
                },
                {
                    name: 'Traghetto',
                    slug: 'traghetto',
                    lat: 40.705267,
                    lng: 17.564237,
                },
                {
                    name: 'Villanova',
                    slug: 'villanova',
                    lat: 40.785117,
                    lng: 17.600948,
                },
                {
                    name: 'Villanova di Ostuni',
                    slug: 'villanova-di-ostuni',
                    lat: 40.790025,
                    lng: 17.585773,
                },
            ],
            aliases: ['ostuni'],
        },
        {
            istat: '075057',
            name: 'Otranto',
            slug: 'otranto',
            province: 'LE',
            centroid: {
                lat: 40.145666,
                lng: 18.490757,
            },
            frazioni: [
                {
                    name: "Baia d'Orte",
                    slug: 'baia-d-orte',
                    lat: 40.130205,
                    lng: 18.508256,
                },
                {
                    name: 'Conca Specchiulla',
                    slug: 'conca-specchiulla',
                    lat: 40.244009,
                    lng: 18.44548,
                },
                {
                    name: 'Frassanito',
                    slug: 'frassanito',
                    lat: 40.230368,
                    lng: 18.452165,
                },
                {
                    name: 'Porto Badisco',
                    slug: 'porto-badisco',
                    lat: 40.080118,
                    lng: 18.483374,
                },
                {
                    name: 'Portorusso',
                    slug: 'portorusso',
                    lat: 40.078464,
                    lng: 18.483061,
                },
                {
                    name: 'Serra Alimini I',
                    slug: 'serra-alimini-i',
                    lat: 40.22121,
                    lng: 18.457176,
                },
                {
                    name: 'Villaggio Altair',
                    slug: 'villaggio-altair',
                    lat: 40.218065,
                    lng: 18.451493,
                },
            ],
            aliases: ['otranto'],
        },
        {
            istat: '073020',
            name: 'Palagianello',
            slug: 'palagianello',
            province: 'TA',
            centroid: {
                lat: 40.611905,
                lng: 16.97495,
            },
            frazioni: [],
            aliases: ['palagianello'],
        },
        {
            istat: '073021',
            name: 'Palagiano',
            slug: 'palagiano',
            province: 'TA',
            centroid: {
                lat: 40.578224,
                lng: 17.037395,
            },
            frazioni: [
                {
                    name: 'Chiatona',
                    slug: 'chiatona',
                    lat: 40.520823,
                    lng: 17.060658,
                },
            ],
            aliases: ['palagiano'],
        },
        {
            istat: '075058',
            name: 'Palmariggi',
            slug: 'palmariggi',
            province: 'LE',
            centroid: {
                lat: 40.131322,
                lng: 18.381176,
            },
            frazioni: [],
            aliases: ['palmariggi'],
        },
        {
            istat: '075059',
            name: 'Parabita',
            slug: 'parabita',
            province: 'LE',
            centroid: {
                lat: 40.051921,
                lng: 18.129526,
            },
            frazioni: [
                {
                    name: 'La Comune-Terrisi',
                    slug: 'la-comune-terrisi',
                    lat: 40.058398,
                    lng: 18.140621,
                },
                {
                    name: 'Rischiazzi',
                    slug: 'rischiazzi',
                    lat: 40.063146,
                    lng: 18.123003,
                },
            ],
            aliases: ['parabita'],
        },
        {
            istat: '075060',
            name: 'Patù',
            slug: 'patu',
            province: 'LE',
            centroid: {
                lat: 39.841299,
                lng: 18.338442,
            },
            frazioni: [
                {
                    name: 'Macchie Romano',
                    slug: 'macchie-romano',
                    lat: 39.82388,
                    lng: 18.302994,
                },
                {
                    name: 'Marina di San Gregorio',
                    slug: 'marina-di-san-gregorio',
                    lat: 39.813717,
                    lng: 18.312962,
                },
            ],
            aliases: ['patu', 'san gregorio'],
        },
        {
            istat: '075061',
            name: 'Poggiardo',
            slug: 'poggiardo',
            province: 'LE',
            centroid: {
                lat: 40.054223,
                lng: 18.379132,
            },
            frazioni: [
                {
                    name: 'Vaste',
                    slug: 'vaste',
                    lat: 40.047433,
                    lng: 18.387063,
                },
            ],
            aliases: ['poggiardo'],
        },
        {
            istat: '075097',
            name: 'Porto Cesareo',
            slug: 'porto-cesareo',
            province: 'LE',
            centroid: {
                lat: 40.262824,
                lng: 17.898418,
            },
            frazioni: [
                {
                    name: 'Corte Vetere',
                    slug: 'corte-vetere',
                    lat: 40.316165,
                    lng: 17.791766,
                },
                {
                    name: 'Eurovillage',
                    slug: 'eurovillage',
                    lat: 40.3063,
                    lng: 17.820058,
                },
                {
                    name: 'Padula Fede',
                    slug: 'padula-fede',
                    lat: 40.291509,
                    lng: 17.803204,
                },
                {
                    name: 'Poggio Bellanova',
                    slug: 'poggio-bellanova',
                    lat: 40.248869,
                    lng: 17.918735,
                },
                {
                    name: 'Punta Grossa',
                    slug: 'punta-grossa',
                    lat: 40.293287,
                    lng: 17.795049,
                },
                {
                    name: 'Punta Prosciutto',
                    slug: 'punta-prosciutto',
                    lat: 40.29452,
                    lng: 17.766087,
                },
                {
                    name: 'Torre Lapillo',
                    slug: 'torre-lapillo',
                    lat: 40.287844,
                    lng: 17.851087,
                },
            ],
            aliases: ['porto cesareo'],
        },
        {
            istat: '075098',
            name: 'Presicce-Acquarica',
            slug: 'presicce-acquarica',
            province: 'LE',
            centroid: {
                lat: 39.899119,
                lng: 18.261731,
            },
            frazioni: [
                {
                    name: 'Acquarica del Capo',
                    slug: 'acquarica-del-capo',
                    lat: 39.908691,
                    lng: 18.249333,
                },
                {
                    name: 'Presicce',
                    slug: 'presicce',
                    lat: 39.899119,
                    lng: 18.261731,
                },
            ],
            aliases: ['presicce', 'presicce acquarica', 'presicceacquarica'],
        },
        {
            istat: '073022',
            name: 'Pulsano',
            slug: 'pulsano',
            province: 'TA',
            centroid: {
                lat: 40.384693,
                lng: 17.35567,
            },
            frazioni: [
                {
                    name: 'Baia dei pescatori',
                    slug: 'baia-dei-pescatori',
                    lat: 40.362552,
                    lng: 17.341031,
                },
                {
                    name: 'Bosco Caggione',
                    slug: 'bosco-caggione',
                    lat: 40.348164,
                    lng: 17.384138,
                },
                {
                    name: 'Le Canne',
                    slug: 'le-canne',
                    lat: 40.357038,
                    lng: 17.357395,
                },
                {
                    name: 'Lido Silvana',
                    slug: 'lido-silvana',
                    lat: 40.342995,
                    lng: 17.383826,
                },
                {
                    name: 'Marina di Pulsano',
                    slug: 'marina-di-pulsano',
                    lat: 40.353013,
                    lng: 17.365016,
                },
                {
                    name: 'Montedarena',
                    slug: 'montedarena',
                    lat: 40.356186,
                    lng: 17.365828,
                },
                {
                    name: 'Villaggio residenziale Fatamorgana',
                    slug: 'villaggio-residenziale-fatamorgana',
                    lat: 40.35214,
                    lng: 17.378438,
                },
            ],
            aliases: ['pulsano'],
        },
        {
            istat: '075063',
            name: 'Racale',
            slug: 'racale',
            province: 'LE',
            centroid: {
                lat: 39.963119,
                lng: 18.093826,
            },
            frazioni: [
                {
                    name: 'Torre Suda',
                    slug: 'torre-suda',
                    lat: 39.957612,
                    lng: 18.031444,
                },
            ],
            aliases: ['racale'],
        },
        {
            istat: '073023',
            name: 'Roccaforzata',
            slug: 'roccaforzata',
            province: 'TA',
            centroid: {
                lat: 40.437424,
                lng: 17.389605,
            },
            frazioni: [],
            aliases: ['roccaforzata'],
        },
        {
            istat: '075064',
            name: 'Ruffano',
            slug: 'ruffano',
            province: 'LE',
            centroid: {
                lat: 39.984092,
                lng: 18.247476,
            },
            frazioni: [
                {
                    name: 'Torrepaduli',
                    slug: 'torrepaduli',
                    lat: 39.990139,
                    lng: 18.257082,
                },
            ],
            aliases: ['ruffano', 'torre paduli'],
        },
        {
            istat: '075065',
            name: 'Salice Salentino',
            slug: 'salice-salentino',
            province: 'LE',
            centroid: {
                lat: 40.385662,
                lng: 17.963748,
            },
            frazioni: [],
            aliases: ['salice', 'salice salentino'],
        },
        {
            istat: '075066',
            name: 'Salve',
            slug: 'salve',
            province: 'LE',
            centroid: {
                lat: 39.858614,
                lng: 18.293817,
            },
            frazioni: [
                {
                    name: 'Lido Marini di Salve',
                    slug: 'lido-marini-di-salve',
                    lat: 39.851879,
                    lng: 18.190057,
                },
                {
                    name: 'Pescoluse',
                    slug: 'pescoluse',
                    lat: 39.837868,
                    lng: 18.254584,
                },
                {
                    name: 'Posto Vecchio',
                    slug: 'posto-vecchio',
                    lat: 39.837212,
                    lng: 18.261931,
                },
                {
                    name: 'Ruggiano',
                    slug: 'ruggiano',
                    lat: 39.870654,
                    lng: 18.315269,
                },
                {
                    name: 'Torre Pali',
                    slug: 'torre-pali',
                    lat: 39.839009,
                    lng: 18.2093,
                },
            ],
            aliases: ['salve'],
        },
        {
            istat: '075095',
            name: 'San Cassiano',
            slug: 'san-cassiano',
            province: 'LE',
            centroid: {
                lat: 40.055909,
                lng: 18.334725,
            },
            frazioni: [],
            aliases: ['san cassiano'],
        },
        {
            istat: '075068',
            name: 'San Cesario di Lecce',
            slug: 'san-cesario-di-lecce',
            province: 'LE',
            centroid: {
                lat: 40.302961,
                lng: 18.159865,
            },
            frazioni: [],
            aliases: ['san cesario', 'san cesario di lecce'],
        },
        {
            istat: '074013',
            name: 'San Donaci',
            slug: 'san-donaci',
            province: 'BR',
            centroid: {
                lat: 40.44938,
                lng: 17.922607,
            },
            frazioni: [],
            aliases: ['san donaci'],
        },
        {
            istat: '075069',
            name: 'San Donato di Lecce',
            slug: 'san-donato-di-lecce',
            province: 'LE',
            centroid: {
                lat: 40.268126,
                lng: 18.184225,
            },
            frazioni: [
                {
                    name: 'Galugnano',
                    slug: 'galugnano',
                    lat: 40.256955,
                    lng: 18.21277,
                },
            ],
            aliases: ['san donato', 'san donato di lecce'],
        },
        {
            istat: '073024',
            name: 'San Giorgio Ionico',
            slug: 'san-giorgio-ionico',
            province: 'TA',
            centroid: {
                lat: 40.456624,
                lng: 17.378704,
            },
            frazioni: [],
            aliases: ['san giorgio ionico'],
        },
        {
            istat: '073025',
            name: 'San Marzano di San Giuseppe',
            slug: 'san-marzano-di-san-giuseppe',
            province: 'TA',
            centroid: {
                lat: 40.454425,
                lng: 17.505607,
            },
            frazioni: [],
            aliases: ['san marzano', 'san marzano di san giuseppe'],
        },
        {
            istat: '074014',
            name: 'San Michele Salentino',
            slug: 'san-michele-salentino',
            province: 'BR',
            centroid: {
                lat: 40.630386,
                lng: 17.633576,
            },
            frazioni: [],
            aliases: ['san michele', 'san michele salentino'],
        },
        {
            istat: '074015',
            name: 'San Pancrazio Salentino',
            slug: 'san-pancrazio-salentino',
            province: 'BR',
            centroid: {
                lat: 40.419133,
                lng: 17.839385,
            },
            frazioni: [],
            aliases: ['san pancrazio', 'san pancrazio salentino'],
        },
        {
            istat: '075071',
            name: 'San Pietro in Lama',
            slug: 'san-pietro-in-lama',
            province: 'LE',
            centroid: {
                lat: 40.308426,
                lng: 18.128623,
            },
            frazioni: [
                {
                    name: 'Donadeo',
                    slug: 'donadeo',
                    lat: 40.310722,
                    lng: 18.132177,
                },
            ],
            aliases: ['san pietro', 'san pietro in lama'],
        },
        {
            istat: '074016',
            name: 'San Pietro Vernotico',
            slug: 'san-pietro-vernotico',
            province: 'BR',
            centroid: {
                lat: 40.491529,
                lng: 17.998918,
            },
            frazioni: [
                {
                    name: 'Campo di Mare',
                    slug: 'campo-di-mare',
                    lat: 40.538984,
                    lng: 18.067826,
                },
                {
                    name: 'Giardino Grande',
                    slug: 'giardino-grande',
                    lat: 40.498559,
                    lng: 17.991949,
                },
                {
                    name: 'Lido Cerano',
                    slug: 'lido-cerano',
                    lat: 40.557831,
                    lng: 18.042922,
                },
            ],
            aliases: ['san pietro vernotico'],
        },
        {
            istat: '074017',
            name: 'San Vito dei Normanni',
            slug: 'san-vito-dei-normanni',
            province: 'BR',
            centroid: {
                lat: 40.656248,
                lng: 17.703752,
            },
            frazioni: [
                {
                    name: 'Rione Giovanni XXIII',
                    slug: 'rione-giovanni-xxiii',
                    lat: 40.661883,
                    lng: 17.704347,
                },
            ],
            aliases: ['san vito', 'san vito de normanni', 'san vito dei normanni'],
        },
        {
            istat: '075067',
            name: 'Sanarica',
            slug: 'sanarica',
            province: 'LE',
            centroid: {
                lat: 40.089123,
                lng: 18.348731,
            },
            frazioni: [],
            aliases: ['sanarica'],
        },
        {
            istat: '075070',
            name: 'Sannicola',
            slug: 'sannicola',
            province: 'LE',
            centroid: {
                lat: 40.094465,
                lng: 18.063427,
            },
            frazioni: [
                {
                    name: 'Chiesanuova',
                    slug: 'chiesanuova',
                    lat: 40.087006,
                    lng: 18.054792,
                },
                {
                    name: 'San Simone',
                    slug: 'san-simone',
                    lat: 40.082145,
                    lng: 18.081861,
                },
            ],
            aliases: ['sannicola'],
        },
        {
            istat: '075072',
            name: 'Santa Cesarea Terme',
            slug: 'santa-cesarea-terme',
            province: 'LE',
            centroid: {
                lat: 40.036323,
                lng: 18.456834,
            },
            frazioni: [
                {
                    name: 'Cerfignano',
                    slug: 'cerfignano',
                    lat: 40.062464,
                    lng: 18.442437,
                },
                {
                    name: 'Porto Miggiano',
                    slug: 'porto-miggiano',
                    lat: 40.030752,
                    lng: 18.448397,
                },
                {
                    name: 'Vitigliano',
                    slug: 'vitigliano',
                    lat: 40.039811,
                    lng: 18.411055,
                },
            ],
            aliases: ['santa cesarea', 'santa cesarea terme'],
        },
        {
            istat: '073026',
            name: 'Sava',
            slug: 'sava',
            province: 'TA',
            centroid: {
                lat: 40.403424,
                lng: 17.558409,
            },
            frazioni: [],
            aliases: ['sava'],
        },
        {
            istat: '075073',
            name: 'Scorrano',
            slug: 'scorrano',
            province: 'LE',
            centroid: {
                lat: 40.091623,
                lng: 18.299629,
            },
            frazioni: [],
            aliases: ['scorrano'],
        },
        {
            istat: '075074',
            name: 'Seclì',
            slug: 'secli',
            province: 'LE',
            centroid: {
                lat: 40.13111,
                lng: 18.102636,
            },
            frazioni: [],
            aliases: ['secli'],
        },
        {
            istat: '075075',
            name: 'Sogliano Cavour',
            slug: 'sogliano-cavour',
            province: 'LE',
            centroid: {
                lat: 40.148823,
                lng: 18.195226,
            },
            frazioni: [],
            aliases: ['sogliano', 'sogliano cavour'],
        },
        {
            istat: '075076',
            name: 'Soleto',
            slug: 'soleto',
            province: 'LE',
            centroid: {
                lat: 40.188966,
                lng: 18.208869,
            },
            frazioni: [],
            aliases: ['soleto', 'sulitu'],
        },
        {
            istat: '075077',
            name: 'Specchia',
            slug: 'specchia',
            province: 'LE',
            centroid: {
                lat: 39.93712,
                lng: 18.297631,
            },
            frazioni: [
                {
                    name: 'Cardigliano',
                    slug: 'cardigliano',
                    lat: 39.946819,
                    lng: 18.268429,
                },
            ],
            aliases: ['specchia'],
        },
        {
            istat: '075078',
            name: 'Spongano',
            slug: 'spongano',
            province: 'LE',
            centroid: {
                lat: 40.017822,
                lng: 18.365632,
            },
            frazioni: [],
            aliases: ['spongano'],
        },
        {
            istat: '075079',
            name: 'Squinzano',
            slug: 'squinzano',
            province: 'LE',
            centroid: {
                lat: 40.436528,
                lng: 18.04182,
            },
            frazioni: [
                {
                    name: 'Casalabate',
                    slug: 'casalabate',
                    lat: 40.49739,
                    lng: 18.121943,
                },
                {
                    name: 'Zona Canuta',
                    slug: 'zona-canuta',
                    lat: 40.511929,
                    lng: 18.097752,
                },
            ],
            aliases: ['squinzano'],
        },
        {
            istat: '073029',
            name: 'Statte',
            slug: 'statte',
            province: 'TA',
            centroid: {
                lat: 40.563225,
                lng: 17.209799,
            },
            frazioni: [
                {
                    name: 'Montetermiti',
                    slug: 'montetermiti',
                    lat: 40.577872,
                    lng: 17.211592,
                },
            ],
            aliases: ['statte'],
        },
        {
            istat: '075080',
            name: 'Sternatia',
            slug: 'sternatia',
            province: 'LE',
            centroid: {
                lat: 40.222125,
                lng: 18.225226,
            },
            frazioni: [],
            aliases: ['chora', 'sternatia'],
        },
        {
            istat: '075081',
            name: 'Supersano',
            slug: 'supersano',
            province: 'LE',
            centroid: {
                lat: 40.017721,
                lng: 18.243229,
            },
            frazioni: [],
            aliases: ['supersano'],
        },
        {
            istat: '075082',
            name: 'Surano',
            slug: 'surano',
            province: 'LE',
            centroid: {
                lat: 40.028322,
                lng: 18.345131,
            },
            frazioni: [],
            aliases: ['surano'],
        },
        {
            istat: '075083',
            name: 'Surbo',
            slug: 'surbo',
            province: 'LE',
            centroid: {
                lat: 40.396028,
                lng: 18.133422,
            },
            frazioni: [
                {
                    name: 'Giorgilorio',
                    slug: 'giorgilorio',
                    lat: 40.386037,
                    lng: 18.149448,
                },
            ],
            aliases: ['surbo'],
        },
        {
            istat: '073027',
            name: 'Taranto',
            slug: 'taranto',
            province: 'TA',
            centroid: {
                lat: 40.471243,
                lng: 17.243228,
            },
            frazioni: [
                {
                    name: 'Borgo Umbertino',
                    slug: 'borgo-umbertino',
                    lat: 40.472467,
                    lng: 17.243223,
                },
                {
                    name: 'Buffoluto',
                    slug: 'buffoluto',
                    lat: 40.496069,
                    lng: 17.280334,
                },
                {
                    name: 'Lama',
                    slug: 'lama',
                    lat: 40.407833,
                    lng: 17.245373,
                },
                {
                    name: 'Lido Azzurro',
                    slug: 'lido-azzurro',
                    lat: 40.519105,
                    lng: 17.133191,
                },
                {
                    name: 'Lido Checca',
                    slug: 'lido-checca',
                    lat: 40.337753,
                    lng: 17.391414,
                },
                {
                    name: 'Quartiere Paolo VI',
                    slug: 'quartiere-paolo-vi',
                    lat: 40.523479,
                    lng: 17.277956,
                },
                {
                    name: 'Solito-Tre Carrare',
                    slug: 'solito-tre-carrare',
                    lat: 40.462943,
                    lng: 17.264197,
                },
                {
                    name: 'Talsano',
                    slug: 'talsano',
                    lat: 40.408547,
                    lng: 17.280451,
                },
                {
                    name: 'Tamburi-Lido Azzurro',
                    slug: 'tamburi-lido-azzurro',
                    lat: 40.494804,
                    lng: 17.228343,
                },
                {
                    name: 'Torretta',
                    slug: 'torretta',
                    lat: 40.333455,
                    lng: 17.41271,
                },
                {
                    name: 'Torretta Mare',
                    slug: 'torretta-mare',
                    lat: 40.334,
                    lng: 17.4027,
                },
            ],
            aliases: ['taranto'],
        },
        {
            istat: '075084',
            name: 'Taurisano',
            slug: 'taurisano',
            province: 'LE',
            centroid: {
                lat: 39.956619,
                lng: 18.214129,
            },
            frazioni: [],
            aliases: ['taurisano'],
        },
        {
            istat: '075085',
            name: 'Taviano',
            slug: 'taviano',
            province: 'LE',
            centroid: {
                lat: 39.983519,
                lng: 18.086826,
            },
            frazioni: [
                {
                    name: 'Marina di Mancaversa',
                    slug: 'marina-di-mancaversa',
                    lat: 39.967453,
                    lng: 18.022261,
                },
            ],
            aliases: ['mancaversa', 'marina di mancaversa', 'tajanu', 'taviano'],
        },
        {
            istat: '075086',
            name: 'Tiggiano',
            slug: 'tiggiano',
            province: 'LE',
            centroid: {
                lat: 39.905819,
                lng: 18.364433,
            },
            frazioni: [
                {
                    name: 'Marina di Tiggiano',
                    slug: 'marina-di-tiggiano',
                    lat: 39.898235,
                    lng: 18.396486,
                },
            ],
            aliases: ['tiggiano'],
        },
        {
            istat: '074018',
            name: 'Torchiarolo',
            slug: 'torchiarolo',
            province: 'BR',
            centroid: {
                lat: 40.484029,
                lng: 18.051619,
            },
            frazioni: [
                {
                    name: 'Lendinuso',
                    slug: 'lendinuso',
                    lat: 40.516629,
                    lng: 18.092869,
                },
                {
                    name: 'Lido Presepe',
                    slug: 'lido-presepe',
                    lat: 40.529414,
                    lng: 18.075211,
                },
                {
                    name: 'Residence Miramare',
                    slug: 'residence-miramare',
                    lat: 40.528004,
                    lng: 18.067836,
                },
                {
                    name: 'Torre San Gennaro',
                    slug: 'torre-san-gennaro',
                    lat: 40.537331,
                    lng: 18.072639,
                },
            ],
            aliases: ['torchiarolo'],
        },
        {
            istat: '074019',
            name: 'Torre Santa Susanna',
            slug: 'torre-santa-susanna',
            province: 'BR',
            centroid: {
                lat: 40.465627,
                lng: 17.735612,
            },
            frazioni: [],
            aliases: ['torre santa susanna'],
        },
        {
            istat: '073028',
            name: 'Torricella',
            slug: 'torricella',
            province: 'TA',
            centroid: {
                lat: 40.354062,
                lng: 17.499392,
            },
            frazioni: [
                {
                    name: 'Librari',
                    slug: 'librari',
                    lat: 40.311567,
                    lng: 17.494228,
                },
                {
                    name: 'Monacizzo',
                    slug: 'monacizzo',
                    lat: 40.327987,
                    lng: 17.496655,
                },
                {
                    name: 'Truglione',
                    slug: 'truglione',
                    lat: 40.314499,
                    lng: 17.471142,
                },
            ],
            aliases: ['torricella'],
        },
        {
            istat: '075087',
            name: 'Trepuzzi',
            slug: 'trepuzzi',
            province: 'LE',
            centroid: {
                lat: 40.405472,
                lng: 18.07062,
            },
            frazioni: [],
            aliases: ['trepuzzi'],
        },
        {
            istat: '075088',
            name: 'Tricase',
            slug: 'tricase',
            province: 'LE',
            centroid: {
                lat: 39.93042,
                lng: 18.355332,
            },
            frazioni: [
                {
                    name: 'Caprarica del Capo',
                    slug: 'caprarica-del-capo',
                    lat: 39.920086,
                    lng: 18.361622,
                },
                {
                    name: 'Depressa',
                    slug: 'depressa',
                    lat: 39.961128,
                    lng: 18.361533,
                },
                {
                    name: 'Lucugnano',
                    slug: 'lucugnano',
                    lat: 39.933956,
                    lng: 18.31962,
                },
                {
                    name: 'Marina Serra',
                    slug: 'marina-serra',
                    lat: 39.913012,
                    lng: 18.392116,
                },
                {
                    name: "Sant'Eufemia",
                    slug: 'sant-eufemia',
                    lat: 39.930209,
                    lng: 18.34774,
                },
                {
                    name: 'Tricase Porto',
                    slug: 'tricase-porto',
                    lat: 39.93174,
                    lng: 18.393661,
                },
                {
                    name: 'Tutino',
                    slug: 'tutino',
                    lat: 39.934823,
                    lng: 18.349974,
                },
            ],
            aliases: ['tricase'],
        },
        {
            istat: '075089',
            name: 'Tuglie',
            slug: 'tuglie',
            province: 'LE',
            centroid: {
                lat: 40.073821,
                lng: 18.098125,
            },
            frazioni: [
                {
                    name: 'Montegrappa',
                    slug: 'montegrappa',
                    lat: 40.07909,
                    lng: 18.093747,
                },
            ],
            aliases: ['tuglie'],
        },
        {
            istat: '075090',
            name: 'Ugento',
            slug: 'ugento',
            province: 'LE',
            centroid: {
                lat: 39.928472,
                lng: 18.162279,
            },
            frazioni: [
                {
                    name: 'Fontanelle',
                    slug: 'fontanelle',
                    lat: 39.876334,
                    lng: 18.140103,
                },
                {
                    name: 'Gemini',
                    slug: 'gemini',
                    lat: 39.911898,
                    lng: 18.185114,
                },
                {
                    name: 'Lido Marini',
                    slug: 'lido-marini',
                    lat: 39.851462,
                    lng: 18.186658,
                },
                {
                    name: 'Lido Marini di Ugento',
                    slug: 'lido-marini-di-ugento',
                    lat: 39.851001,
                    lng: 18.184927,
                },
                {
                    name: 'Mare Verde',
                    slug: 'mare-verde',
                    lat: 39.901122,
                    lng: 18.089029,
                },
                {
                    name: 'Torre Mozza',
                    slug: 'torre-mozza',
                    lat: 39.860168,
                    lng: 18.163195,
                },
                {
                    name: 'Torre San Giovanni',
                    slug: 'torre-san-giovanni',
                    lat: 39.888941,
                    lng: 18.113956,
                },
            ],
            aliases: ['ugento', 'uxentum'],
        },
        {
            istat: '075091',
            name: 'Uggiano la Chiesa',
            slug: 'uggiano-la-chiesa',
            province: 'LE',
            centroid: {
                lat: 40.101724,
                lng: 18.449333,
            },
            frazioni: [
                {
                    name: 'Casamassella',
                    slug: 'casamassella',
                    lat: 40.114885,
                    lng: 18.451984,
                },
            ],
            aliases: ['uggiano', 'uggiano la chiesa'],
        },
        {
            istat: '075092',
            name: 'Veglie',
            slug: 'veglie',
            province: 'LE',
            centroid: {
                lat: 40.335126,
                lng: 17.965219,
            },
            frazioni: [
                {
                    name: 'Monteruga',
                    slug: 'monteruga',
                    lat: 40.353593,
                    lng: 17.842029,
                },
            ],
            aliases: ['veglie'],
        },
        {
            istat: '075093',
            name: 'Vernole',
            slug: 'vernole',
            province: 'LE',
            centroid: {
                lat: 40.289527,
                lng: 18.303527,
            },
            frazioni: [
                {
                    name: 'Acaya',
                    slug: 'acaya',
                    lat: 40.334476,
                    lng: 18.2977,
                },
                {
                    name: 'Acquarica',
                    slug: 'acquarica',
                    lat: 40.307157,
                    lng: 18.315585,
                },
                {
                    name: 'Campo Verde',
                    slug: 'campo-verde',
                    lat: 40.376558,
                    lng: 18.305933,
                },
                {
                    name: 'Pisignano',
                    slug: 'pisignano',
                    lat: 40.304442,
                    lng: 18.271746,
                },
                {
                    name: 'Strudà',
                    slug: 'struda',
                    lat: 40.319333,
                    lng: 18.282044,
                },
                {
                    name: 'Vanze',
                    slug: 'vanze',
                    lat: 40.322078,
                    lng: 18.318144,
                },
            ],
            aliases: ['acquarica di lecce', 'vernole'],
        },
        {
            istat: '074020',
            name: 'Villa Castelli',
            slug: 'villa-castelli',
            province: 'BR',
            centroid: {
                lat: 40.584527,
                lng: 17.474605,
            },
            frazioni: [
                {
                    name: 'Antoglia',
                    slug: 'antoglia',
                    lat: 40.568254,
                    lng: 17.474986,
                },
                {
                    name: 'Lizzito',
                    slug: 'lizzito',
                    lat: 40.577785,
                    lng: 17.479252,
                },
                {
                    name: 'Montescotano',
                    slug: 'montescotano',
                    lat: 40.590989,
                    lng: 17.480054,
                },
            ],
            aliases: ['villa castelli'],
        },
        {
            istat: '075094',
            name: 'Zollino',
            slug: 'zollino',
            province: 'LE',
            centroid: {
                lat: 40.206006,
                lng: 18.250589,
            },
            frazioni: [],
            aliases: ['tsuddinu', 'zollino'],
        },
    ],
};
//# sourceMappingURL=data.js.map